jQuery(document).ready(function($){
  
  $(".description").children().each(function (i, child) {
 //  if ( $(child).is("div") ) {
 //    $(child).contents().unwrap(); // remove divs
 //  }
});
	
	// This first section is all about formatting the content correctly for tabs
	
	// Add the opening list tag before the first H5 within the description 
	$('.description h5:first-of-type').before('<ul class="tabs" />');
	
	// Loop through each H5 in the description
	$('.description h5').not(":empty").each(function(index, value){
	    // Assign them each a number, in order
		var num = index + 1;
		
		// For each H5, wrap everything from after the heading to just before the next one in a div
		// Give each div a unique ID that includes those assigned numbers
	    $(this).nextUntil('h5').wrapAll('<div class="tab-content" id="tab' + num + '" />');
	    
	    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
	    $(this).wrap('<li class="single-tab"><a href="#tab' + num + '"></a></li>');
	});
	
	// Wrap the whole list and the tab content divs in a surrounding div
	$('ul.tabs, .tab-content').wrapAll('<div class="tab-area" />');
	
	// Move that surrounding div after the form
	$('.tab-area').appendTo('.content');
	
	// Loop through the list items (the tab headers)
	$('.single-tab').each(function(){
	    // Move them into the list element
		$(this).appendTo('ul.tabs');
	});
	
	
	// The rest of this is the actual tab functionality, from http://www.jacklmoore.com/notes/jquery-tabs/
	
});